import { CompletedTask } from '@/hooks/api/quanta/useQuantaMissionTasks';

import TaskCard from './TaskCard';

interface TaskHistoryProps {
  completedTasks: CompletedTask[];
}

const TaskHistory: React.FC<TaskHistoryProps> = ({ completedTasks }: TaskHistoryProps) => {
  return (
    <div className='flex flex-1 flex-col gap-4'>
      <p className='text-xl text-text-secondary'>Tasks completed to date:</p>
      <div className='flex flex-grow flex-col gap-2 h-0 overflow-y-auto'>
        {completedTasks.length > 0 ? (
          completedTasks.map(({ tasks_id, mission_id, name, points, max_multiplier, multiplier, completion_date, icon }, index) => (
            <TaskCard
              key={tasks_id ?? index}
              missionId={mission_id}
              title={name}
              points={points}
              maxMultiplier={max_multiplier}
              multiplier={multiplier}
              completionDate={completion_date}
              icon={icon}
            />
          ))
        ) : (
          <div className='flex items-center justify-center px-4 py-3 rounded-lg bg-[rgba(17, 16, 21, 0.50)] backdrop-blur-[5.85px] [background-image:repeating-linear-gradient(90deg,_#28272c,_#28272c_9px,_transparent_9px,_transparent_18px),_repeating-linear-gradient(180deg,_#28272c,_#28272c_9px,_transparent_9px,_transparent_18px),_repeating-linear-gradient(90deg,_#28272c,_#28272c_9px,_transparent_9px,_transparent_18px),_repeating-linear-gradient(180deg,_#28272c,_#28272c_9px,_transparent_9px,_transparent_18px)] [background-position:left_top,_right_top,_left_bottom,_left_top] [background-repeat:repeat-x,_repeat-y,_repeat-x,_repeat-y] [background-size:100%_1px,_1px_100%,_100%_1px,_1px_100%]'>
            <p className='text-lg text-text-disabled'>You don&apos;t have any task completed at the moment</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskHistory;
